import { ShieldCheck, Users, Zap, type LucideIcon } from "lucide-react";
import { Reveal } from "./motion";

const features: { Icon: LucideIcon; title: string; body: string; accent: string }[] = [
  {
    Icon: ShieldCheck,
    title: "Bring your own ROM",
    body: "Your game files load straight into the browser and never leave it. Nothing is uploaded to a server, ever.",
    accent: "var(--crt-neon)",
  },
  {
    Icon: Zap,
    title: "Zero install",
    body: "It runs right inside the voice call as a Discord Activity. No clients, no setup, no patch notes.",
    accent: "var(--crt-blurple-bright)",
  },
  {
    Icon: Users,
    title: "Single-player now",
    body: "Solo play and shared-screen spectating today — synced multiplayer is coming down the pipe.",
    accent: "var(--crt-cyan)",
  },
];

export function FeatureStrip() {
  return (
    <section className="relative mx-auto max-w-6xl px-5 py-24">
      <div className="lp-divider mb-16" />
      <div className="grid gap-5 md:grid-cols-3">
        {features.map((f, i) => (
          <Reveal key={f.title} delay={i * 0.1}>
            <div className="lp-panel flex h-full flex-col gap-4 p-7">
              <span
                className="flex h-14 w-14 items-center justify-center rounded-xl"
                aria-hidden
                style={{
                  background: "rgba(255,255,255,0.04)",
                  border: `1px solid ${f.accent}`,
                  boxShadow: `0 0 18px -4px ${f.accent}`,
                  color: f.accent,
                }}
              >
                <f.Icon size={26} strokeWidth={1.75} />
              </span>
              <h3 className="text-lg font-bold text-text-primary">{f.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: "var(--crt-ink-dim)" }}>
                {f.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
